import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import {
  PmTechnicalIP, Equipment, SaveStatusObj, EnggDrawIP,
  SOModule, SaveEventType, SalesOrder, EquipmentType, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, ValidationSummary, SSOStatus,
  RequestDateToken, BreakerType, BreakerPS, CommentsOnSubmission, GenFileUploads, MarketingIP, DeliveryTermDef
} from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog'
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'pm-technical-suborder',
  templateUrl: './pm-technical-suborder.component.html',
  styleUrls: ['./pm-technical-suborder.component.css']
})
export class PmTechnicalSuborderComponent implements OnInit, OnChanges {
  @Input() pmTechSubSoObj: PmTechnicalIP;
  @Input() soLockObtained:boolean;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  // @Output() DeleteSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  selected = 'live';

 
  //_typeOfEquipments:Array<EquipmentType> = []; 
  disableForm: boolean = false;
  // isNotSuperAdmin: boolean = false;
  modifyPlanDate: boolean = false;
  modifyReqDate: boolean = false;
  projectExecStatus: string = 'live';
  public _SSOStatus = SSOStatus;
  inputDisableMessage: string = 'This form is not yet enabled';
  maxLength:number = 6;
  Hvr:any = {}; 
  totalpanl: number = 0;
  DaysMin : number = 0;
  DaysMax : number = 10;

  
  constructor(public _dataService: DataService, public dialog: MatDialog) { }
  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.totalpanl = 5;
    //this.totalpanl = this.pmTechSubSoObj.totalpanelquant;
    // console.log(this.totalpanl);
    //this._typeOfEquipments = this._dataService.typeOfEquipments;
    // this.ngOnChanges();
    this.noOfDaysCalc();
  }
  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if(!this.pmTechSubSoObj.isInputEnabled){
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if(!this._dataService.hasPmTechnicalEditAccess(this.pmTechSubSoObj)){
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else{
      this.disableForm = false;
    }
    // this.disableForm = !this.pmTechSubSoObj.isInputEnabled;
    // if (this.disableForm == false) {
    //   this.disableForm = !this._dataService.hasPmTechnicalEditAccess(this.pmTechSubSoObj);
    //   // console.log(this.isNotSuperAdmin)
     
    //   if (this.disableForm == true) {
    //     this.inputDisableMessage = "You don't have EDIT ACCESS.";
    //   }
    // }
    this.pmTechSubSoObj.drawingUploads.disableUpload = this.disableForm;
    this.pmTechSubSoObj.drawingUploads.headerStr = 'Customer Approved Drawing Uploads' + " - " + this.pmTechSubSoObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.pmTechSubSoObj.parentSubSORef.subOrderNoId;
    this.pmTechSubSoObj.contractUploads.disableUpload = this.disableForm;
    this.pmTechSubSoObj.contractUploads.headerStr = 'Contractual Change Uploads' + " - " + this.pmTechSubSoObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.pmTechSubSoObj.parentSubSORef.subOrderNoId;
  }
  equipmentArray: Array<any> = [1];
  isContractualDlvryEnabled(): boolean{
    return (this.disableForm == false) && 
    (this._dataService.isAdmin == true || this._dataService.isPMHOD == true);
  }
  addNewBlock() {
    let brkps: BreakerPS = new BreakerPS("", 0);
    let brkpslist: Array<BreakerPS> = [];
    brkpslist.push(brkps);
    this.pmTechSubSoObj.addEquipmentList(new Equipment("", "", "", "", "", "", "", 0, brkpslist));
  }
  removeBlock(equipment: any) {
    this.pmTechSubSoObj.removeEquipment(equipment);
  }
  // total(breakerquant:any){
  //   let brkps: BreakerPS = new BreakerPS("", 0);
  //   for( var i=0 ; i<brkps[1] ; i++){
  //       breakerquant = brkps[i]
  //   }
  // }

  noOfDaysCalc(){
    let _mktDelTerm = this.pmTechSubSoObj.parentSORef.marketingIP.deliveryTerm;
    let _tempDelTrm = this._dataService.getDeliveryTermName(_mktDelTerm);   
    switch(_tempDelTrm){
      case "Ex-Works":
        this.DaysMin = 1;
        this.DaysMax = 2;
        break;
      case "FOR":
          this.DaysMin = 1;
          this.DaysMax = 15;
          break;
      case "FCA":
        this.DaysMin = 3;
        this.DaysMax = 10;
        break;
      case "FOB":
        this.DaysMin = 1;
        this.DaysMax = 7;
        break;
      case "CIF":
      case "CPT":
      case "DDP":
        this.DaysMin = 10;
        this.DaysMax = 45;
        break;

    }
  }
  onDaysChange(_eventDays){
   let _val = _eventDays.target.value;
    if(_val > this.DaysMax || _val < this.DaysMin){
      alert("Please enter value between "+this.DaysMin +" - "+this.DaysMax);
    }
    
  }
  addNewbreakerPSBlock(_equip: Equipment) {
    if (_equip) {
      _equip.addBreakerPS(new BreakerPS("", 0));
    }
  }
  removebreakerPSBlock(_equip: Equipment, _brkrPS: BreakerPS) {
    if (_equip && _brkrPS) {
      _equip.removeBreakerPS(_brkrPS);
    }
  }
  addCommentsBlock() {
    this.pmTechSubSoObj.addCommentslist(new CommentsOnSubmission(null, null));
  }
  removeCommentsBlock(_index:number){
    this.pmTechSubSoObj.commentsDateList.splice(_index,1);
  }
  removePaymentCond(_pmtec: PmTechnicalIP, _comm: CommentsOnSubmission) {
    if (_pmtec && _comm) {
      _pmtec.removeCommentslist(_comm);
    }
  }

  actualDateChangeHandler(_actDateHeader: string, _actDate: Date, _actDateChanged: Date, _actTokenKeyName: string, _plndDateHeader: string, _plndDate: Date, ): void {
    let _actDateChangeObj: ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader,
      _actDateChanged, this.pmTechSubSoObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate: Date = this.pmTechSubSoObj[_actTokenKeyName].actualDate;
    this.pmTechSubSoObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.pmTechSubSoObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.pmTechSubSoObj[_actTokenKeyName] =
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.pmTechSubSoObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }
  plannedDateChangeHandler(_plndDateHeader: string, _plndTokenKeyName: string, _plndDate: Date, _plndDateChanged: Date): void {
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)",
      _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.pmTechSubSoObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.pmTechSubSoObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.pmTechSubSoObj[_plndTokenKeyName] =
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.pmTechSubSoObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }
  requestDateChangeHandler(_reqDateHeader: string, _reqTokenKeyName: string, _plndReqDate: Date, _reqDateChanged: Date): void {
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)",
      _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.pmTechSubSoObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.pmTechSubSoObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.pmTechSubSoObj[_reqTokenKeyName] =
          new RequestDateToken(new Date(_reqDateChanged.getTime()), true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.pmTechSubSoObj[_reqTokenKeyName].requestDate = _plndReqDate;
      }
    });
  }
  showSSoDrawValidation() {
    let _validList: Array<ValidationItem> = [];
    // _validList.push(new ValidationItem("Actual Drawing Approval Date", (this.pmTechSubSoObj.actualDrawingApprovalDate ? true : false), " required to move to Engg Drawing."));
    _validList.push(new ValidationItem("No. of days for Goods to Reach at Site", (this.pmTechSubSoObj.DaysgoodsReach ? true : false), " required to move to Engg Drawing."));
    
    if (this.pmTechSubSoObj.parentSORef.marketingIP.contractDeliveryDateFirm !=null && this.pmTechSubSoObj.parentSORef.marketingIP.isContractDeliveryDateFirm == true) {
    _validList.push(new ValidationItem("Customer Requested Date", (this.pmTechSubSoObj.rotddate ? true : false), " required to move to Engg Drawing."));
    }
    this.pmTechSubSoObj.equipmentList.forEach(val =>{
      var equiApp = this.isSpecifiedEquipType(val.equipmentType)
      var equiName = this._dataService.getEquipmentTypeName(val.equipmentType)
      if(equiApp == true){
        // if (val.earthSwithApplicability !=null) {
          _validList.push(new ValidationItem("Imported Earth Switch Applicability "+equiName, (val.earthSwithApplicability ? true : false), " required to move to Engg Drawing."));
        // }
      }
      });

      this.pmTechSubSoObj.equipmentList.forEach(val =>{
        var equiApp = this.isSpecifiedEquipType(val.equipmentType)
        var equiName = this._dataService.getEquipmentTypeName(val.equipmentType)
        if(equiApp == true){
        // if (val.earthSwithApplicability!='' && val.isEarthSwitchApplicable) {
          if (val.isEarthSwitchApplicable) {
          _validList.push(new ValidationItem("Imported Earth Switch Quantity "+equiName, (val.earthSwitchQuantity ? true : false), " required to move to Engg Drawing."));
            }
          }
        });
     
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  showSSoPlanningValidation() {
    let _validList: Array<ValidationItem> = [];
    // _validList.push(new ValidationItem("Actual Drawing Approval Date", (this.pmTechSubSoObj.actualDrawingApprovalDate ? true : false), " required to move to Engg Drawing."));
    _validList.push(new ValidationItem("No. of days for Goods to Reach at Site", (this.pmTechSubSoObj.DaysgoodsReach ? true : false), " required to move to Planning."));

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  showSSOSCMValidation() {
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("FCM info for CT Finalization Given By PM To SCM Actual Date", (this.pmTechSubSoObj.actualCtFinalizationDate ? true : false), " required to move to SCM."));
    // console.log(_validList);
    if (this.pmTechSubSoObj.isSplMatPriceDatesEnabled == true && this.pmTechSubSoObj.isSpecailPricesActualEnabled != true) {
      _validList.push(new ValidationItem("Special Material Price Actual date Required", (this.pmTechSubSoObj.splMatFinalizationActualDate ? true : false), " required to move to SCM."));
    }
    _validList.push(new ValidationItem("No. of days for Goods to Reach at Site", (this.pmTechSubSoObj.DaysgoodsReach ? true : false), " required to move to SCM."));
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    // console.log(_validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  datasheetSaveLockValidation() {
    let _validList: Array<ValidationItem> = [];
    if(!this.pmTechSubSoObj.parentSORef.marketingIP.pmHandoverDetails.handoverStatus && this.pmTechSubSoObj.parentSORef.hasDatasheetInSO){
      _validList.push(new ValidationItem("PM Handover Approval", (this.pmTechSubSoObj.parentSORef.marketingIP.pmHandoverDetails.handoverStatus ? true : false), "for Datasheet is required."));
    }
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    // console.log(_validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  saveSso(_submitToNextSection: boolean, ssoSubmitTo: SSOStatus = SSOStatus.Not_Started) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
        null,
        ssoSubmitTo
      ));
    }
  }
  saveSsoEnggProcLog(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Engg_Procurement_From_PM_Tech | SSOStatus.Logistic_From_PM_Tech){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }

  // deleteSSo(_submitToNextSection:boolean, ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
  //   if(this.DeleteSubSalesOrder){
  //     this.DeleteSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
  //       (_submitToNextSection == true ? SaveEventType.Submit_To_Next: SaveEventType.Delete_SubSale_Order),
  //       null,
  //       ssoSubmitTo));
  //   }
  // }
  deleteSSo(_deleteSO: boolean) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  cachedEquipments: any  = {};
  filterEquipments(_prodVariantId: string): Array<EquipmentType> {
    //caching method to avoid performance lags 
    if (this.cachedEquipments[_prodVariantId] != null) {
      return this.cachedEquipments[_prodVariantId];
    }
    this.cachedEquipments[_prodVariantId] = this._dataService.typeOfEquipments.filter((_obj: EquipmentType) => {
      if ((_obj.variantIDs.length == 0) || _obj.variantIDs.indexOf(_prodVariantId) >= 0) {
        return true;
      }
      return false;
    });
    return this.cachedEquipments[_prodVariantId];
  }
  cachedFilterBreakerTypes: any = {};
  filterBreakerTypes(_prodVariantId: string): Array<BreakerType> {
    //caching method to avoid performance lags 
    if (this.cachedFilterBreakerTypes[_prodVariantId] != null) {
      return this.cachedFilterBreakerTypes[_prodVariantId];
    }
    this.cachedFilterBreakerTypes[_prodVariantId] = this._dataService.breakerType.filter((_obj: BreakerType) => {
      if ((_obj.variantIDs.length == 0) || _obj.variantIDs.indexOf(_prodVariantId) >= 0) {
        return true;
      }
      return false;
    });
    return this.cachedFilterBreakerTypes[_prodVariantId];
  }
  rvnuMonthMonthHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.pmTechSubSoObj.plannedRevnueMonth = new Date(normalizedYear.year(), normalizedYear.month(), 1);
    datepicker.close();
  }
  invcMonthMonthHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.pmTechSubSoObj.invoicingmonth = new Date(normalizedYear.year(), normalizedYear.month(), 1);
    datepicker.close();
  }
  manfMonthMonthHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>){
    this.pmTechSubSoObj.parentSubSORef.planningIP.plannedManufacturingMonth = new Date(normalizedYear.year(), normalizedYear.month(), 1);
    datepicker.close();
  }
  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }
  projExecStatusChange(_evnt) {
    // console.log('im invited', this.projectExecStatus, _evnt)
  }
  counter: number = 1;
  cacheVSCQtyEnabled: any = {};
  cacheSpecifiedEquipType: any = {};
  isVSCQtyEnabled(_variantId: string, _equipTypeId: string, _brkrTypeID) {
    
    var cacheKey: string = _variantId + "," + _equipTypeId + "," + _brkrTypeID;
    if (this.cacheVSCQtyEnabled[cacheKey] != null)
      return this.cacheVSCQtyEnabled[cacheKey];
    if (this.isSpecifiedEquipType(_equipTypeId) == false) {
      this.cacheVSCQtyEnabled[cacheKey] = false;
      return false;
    }
    var _result: boolean = this._dataService.isVSCQtyEnable(_variantId, _equipTypeId, _brkrTypeID);
    this.cacheVSCQtyEnabled[cacheKey] = _result;
    return _result;
  }
  isSpecifiedEquipType(_equipTypeId: string) {
    if (_equipTypeId == null || _equipTypeId == '') {
      return false;
    }
    if (this.cacheSpecifiedEquipType[_equipTypeId] != null){
      return this.cacheSpecifiedEquipType[_equipTypeId];
    }
    var _result = !this._dataService.isGeneralEquipmentType(_equipTypeId);
    this.cacheSpecifiedEquipType[_equipTypeId] = _result;
    return _result;
  }
  CustomerApprovedUploadsClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.pmTechSubSoObj.drawingUploads);
  }
  ContractualDateUploadsClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.pmTechSubSoObj.contractUploads);
  }
  hasSpecifiedEquipType(_prodVariantId:string, _equipTypeId: string){
    
    if(_prodVariantId == null || _prodVariantId == '') return false;
    let _avlbleEquips:Array<EquipmentType> = this.filterEquipments(_prodVariantId);
    let _equipIndex:number = _avlbleEquips.findIndex((_tmpEquip:EquipmentType) => {
      return _tmpEquip.equipmentTypeId == _equipTypeId; 
    });
    if(_equipIndex < 0) return false;
    return this.isSpecifiedEquipType(_equipTypeId);
  }
  dateValidation(){
    var dateTime = new Date("2020-10-27");
  //  console.log("this.pmTechSubSoObj.parentSORef.marketingIP.clearPoReceiptDate::",this.pmTechSubSoObj.parentSORef.marketingIP.clearPoReceiptDate)
   if(this.pmTechSubSoObj.parentSORef.marketingIP.clearPoReceiptDate < dateTime){
     //console.log("dejaskdxjsad",this.pmTechSubSoObj.parentSORef.marketingIP.clearPoReceiptDate )
    return false;
   }else{
     return true;
   }
  }
      
  test(_equipmentValue){    
    let totalQunatity : number = 0   
    let remainingPanel :number; 
    let mktg : MarketingIP
    var _tmpDate = mktg.clearPoReceiptDate;  
    let dateTime = new Date("2020-10-27")
    this.pmTechSubSoObj.equipmentList.forEach((_equipment) => {
      totalQunatity += _equipment.panelQuantityNum;
    })
    // console.log("Remianing Panel",totalQunatity)
    remainingPanel = parseFloat(this.pmTechSubSoObj.totalpanelquant) - totalQunatity; 
    if(dateTime<_tmpDate ){
      if(totalQunatity > parseFloat(this.pmTechSubSoObj.totalpanelquant)){             
        _equipmentValue.panelQuantity = 0;
      } 
      if(remainingPanel < 9){
        this.maxLength = 1;
      }else if(remainingPanel < 99){
        this.maxLength = 2;
      }else if(remainingPanel < 999){
        this.maxLength = 3;
      }
    }  
  }
  
  test2(_equipmentValue){    
    let totalcontract : number = 0   
    let remainingcontract: number = 0  
    let mktg : MarketingIP
    var _tmpDate = mktg.clearPoReceiptDate;  
    let dateTime = new Date("2020-10-27")
    this.pmTechSubSoObj.equipmentList.forEach((_equp) => {
    
      totalcontract +=parseFloat(_equp.contractualValue) ;
    })
    remainingcontract = parseFloat(this.pmTechSubSoObj.totalcontval) - totalcontract; 
    if(dateTime<_tmpDate ){
      if(totalcontract > parseFloat(this.pmTechSubSoObj.totalcontval)){             
        _equipmentValue.contractualValue = 0;
      } 
      if(remainingcontract < 9){
        this.maxLength = 1;
      }else if(remainingcontract < 99){
        this.maxLength = 2;
      }else if(remainingcontract < 999){
        this.maxLength = 3;
      }  
    }
  }
}